import { InstanceScreen } from 'component/navigation/instance';
import { useTranslation } from 'component/translation';
import { Stack } from 'expo-router';
import { t } from 'util/stdtypes';

export default function EditorialDashboardNewStoryScreen() {
    const title = useTranslation(t('story_dash.add_title', 'Add story'));
    return (
        <>
            <Stack.Screen options={{ title }} />
            <InstanceScreen screenKey='stories/new' />
        </>
    );
}
